import React            from 'react';
import PropTypes        from 'prop-types';
import classNames       from 'classnames';

import useInput         from './useInput';


import styles           from './Input.styl';

function Input(props) {
    const {
        className,
        inputClassName,
        type,
        value,
        error,
        ...rest
    } = props;

    const {
        handleChange
    } = useInput(props);

    return  (
        <div
            className={classNames(styles.Input, className, {
                [styles.error]: error
            })}
            {...rest}
        >
            {type === 'textarea'
                ? (
                    <textarea
                        {...rest}
                        className={classNames(styles.input, styles.textarea)}
                        value    = {value}
                        onChange = {handleChange}
                    />
                )
                : (
                    <input
                        {...rest}
                        className={classNames(styles.input, inputClassName)}
                        value    = {value}
                        onChange = {handleChange}
                    />
                )
            }
            <div className={styles.errorText}>
                {error}
            </div>
        </div>
    );
}

Input.propTypes = {
    className      : PropTypes.string,
    inputClassName : PropTypes.string,
    type           : PropTypes.string,
    value          : PropTypes.string,
    error          : PropTypes.string
};

Input.defaultProps = {
    className      : '',
    inputClassName : '',
    type           : 'text',
    value          : '',
    error          : ''
};

export default Input;
